
<template>
  <div ref="mainStage" id="mainStage" class="stageBox">
    <div id="up-size" class="abs-block">
        <b class="speedee">+15.-</b>
    </div>
    <div id="price-left" class="abs-block price-block">
        <ul class="speedee">
            <li><b>109</b></li>
            <li><b>159</b></li>
            <li><b class="lh-115">205</b></li>
            <li><b>230</b></li>
        </ul>
    </div>
      <div id="price-right" class="abs-block price-block">
          <ul class="speedee">
              <li><b>155</b></li>
              <li><b>175</b></li>
              <li><b class="lh-115">215</b></li>
              <li><b>364</b></li>
          </ul>
      </div>
    <vue-scene
            :keyframes="keyCursors"
            :playSpeed="1"
            :time="0"
            :css="false"
            :autoplay="true"
            :ready="true"
            easing="ease"
            iterationCount="infinite"
    >
        <div class="cursors">
            <img id="left_box" class="cursor_box" src="/images/box_line.svg" style="width: 750px;" alt="box">
            <img id="right_box" class="cursor_box" src="/images/box_line.svg" style="width: 750px;" alt="box">
        </div>

    </vue-scene>
    <vue-scene
            :keyframes="keyframes"
            :playSpeed="1"
            :time="0"
            :css="false"
            :autoplay="true"
            :ready="true"
            easing="ease"
            iterationCount="infinite"
    >
        <div class="burger">
            <img id="burger1" class="burger-child" src="/images/image01.png" alt="burger-item"/>
            <img id="burger6" class="burger-child" src="/images/image06.png" alt="burger-item"/>
            <img id="burger7" class="burger-child" src="/images/image07.png" alt="burger-item"/>
            <img id="burger8" class="burger-child" src="/images/image08.png" alt="burger-item"/>
            <!--<ObjectBlock type="Image" data-source="/images/image01.png"></ObjectBlock>-->
        </div>
    </vue-scene>
  </div>
</template>

<script>
  /* eslint-disable
  no-console,
  no-unused-vars
   */
  import { TimelineMax , TweenMax, CSSPlugin, ScrollToPlugin, Draggable, Elastic } from 'gsap/all'
  import { CustomEase } from '@/gsap/CustomEase'
  import ObjectBlock from '@/components/ObjectBlock'
  import { VueScene, VueSceneItem } from "vue-scenejs";
  import Timeline, { SelectEvent } from "@scenejs/timeline";
  import _ from 'lodash'
  export default {
    components: {
      //ObjectBlock,
      VueScene,
      // eslint-disable-next-line vue/no-unused-components
      VueSceneItem,
    },

    data () {
      return {
        keyCursors : {
            ".cursors .cursor_box":  i => ({
                0: {
                    "position" : "absolute",
                    "opacity" : 0,
                    "transform": "translate(0px, -500px) scale(1)",
                }
            }),
            ".cursors #left_box": {
                0: {
                    "transform": "translate(0px, -500px) scale(1)",
                },
                0.5: {
                    "opacity" : 1,
                    "transform": "translate(0px, -500px) scale(1)",
                },
                4: {
                    "transform": "translate(0px, -500px) scale(1)",
                },
                5: {
                    "transform": "translate(0px, -402px) scale(1)",
                },
                9: {
                    "transform": "translate(0px, -402px) scale(1)",
                },
                10: {
                    "transform": "translate(0px, -302px) scale(1)",
                },
                14: {
                    "transform": "translate(0px, -302px) scale(1)",
                },
                15: {
                    "transform": "translate(0px, -198px) scale(1)",
                },
                19: {
                    "opacity" : 1
                },
                20: {
                    "opacity" : 0
                },
            },
            ".cursors #right_box": {
                0: {
                    "transform": "translate(950px, -500px) scale(1)",
                },
                0.5: {
                    "opacity" : 1,
                    "transform": "translate(950px, -500px) scale(1)",
                },
                4: {
                    "transform": "translate(950px, -500px) scale(1)",
                },
                5: {
                    "transform": "translate(950px, -402px) scale(1)",
                },
                9: {
                    "transform": "translate(950px, -402px) scale(1)",
                },
                10: {
                    "transform": "translate(950px, -302px) scale(1)",
                },
                14: {
                    "transform": "translate(950px, -302px) scale(1)",
                },
                15: {
                    "transform": "translate(950px, -198px) scale(1)",
                },
                19: {
                    "opacity" : 1
                },
                20: {
                    "opacity" : 0
                },
            }
        },
        keyframes: {
            ".burger .burger-child":  i => ({
                0: {
                    "position" : "absolute",
                    "opacity" : 0,
                    "transform": "translate(210px, 708px) scale(1)",
                }
            }),

            ".burger #burger1": {
                0: {
                    "opacity": 0,
                    "transform": "translate(210px, 708px)",
                },
                1: {
                    "opacity": 1,
                },
                8: {
                    "opacity": 1,
                },
                10: {
                    "opacity": 0,
                }
            },
            ".burger #burger7": {
                8: {
                    "transform": "translate(210px, 680px) scale(1)",
                    "opacity": 0,
                },
                10: {
                    "opacity": 1,
                },
                19: {
                    "opacity": 1,
                },
                20: {
                    "opacity": 0,
                }
            },
            ".burger #burger6": {
                0: {
                    "opacity": 0,
                    "transform": "translate(1095px, 680px)",
                },
                1: {
                    "opacity": 1,
                },
                8: {
                    "opacity": 1,
                },
                10: {
                    "opacity": 0,
                }
            },
            ".burger #burger8": {
                8: {
                    "transform": "translate(1095px, 620px)",
                    "opacity": 0,
                },
                10: {
                    "opacity": 1,
                },
                19: {
                    "opacity": 1,
                },
                20: {
                    "opacity": 0,
                }
            },
        },
        editor : true,
      }
    },
    mounted() {
      const timeline = new TimelineMax();
    },
    methods: {
      changeImage(element){
        element.target.src = "/images/image07.png";
      }
    }
  }
</script>


<style lang="scss">
  body {

  }
  .stageBox {
    position: absolute;
    background-image: url('/images/tiny_bg_beef_01.png');
    background-size: contain;
    height:1080px;
    width: 1920px;
    overflow: hidden;
  }
  .box {
    height: 60px;
    width: 60px;
    background: red;
  }

  .circles {
    position: relative;
    width: 300px;
    height: 300px;
    margin: auto;
  }
  .circles .circle {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 300px;
    height: 300px;
    border: 150px solid black;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
  }
  .abs-block {
      position: absolute;
  }
  #up-size {
    top:90px;
    left:770px;
  }
  #up-size b {
      color:white;
      font-family: "Speedee",sans-serif;
      font-weight: bold;
      font-size: 53px;
  }
    .speedee {
        color:white;
        font-family: "Speedee",sans-serif;
        font-weight: bold;
    }
    .price-block {
        line-height: 90px;
        font-size: 50px;
        b::after {
            content : ".-";
        }
    }
    .lh-115 {
        line-height: 115px;
    }
    #price-left {
        top:202px;
        left: 700px;
    }
  #price-right {
      top:202px;
      right: 150px;
  }
</style>